import { ApiServiceService } from './../services/api-service.service';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private route: Router) { }
  canActivate(): boolean {
    if (localStorage.getItem('LoginData')) {
      return true;
    } else {
      this.route.navigate(['/login']);
      return false;
    }
  }
}
